export default __webpack_public_path__ + "static/media/prev-C1A-3.099c0fce.png";